import 'bootstrap/dist/css/bootstrap.min.css';
import { useState } from 'react';
import "./Register.css"
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BaseURL from '../Util/BaseURL';
import toastify from '../Util/toastify';
const Register = () => {
    var nav = useNavigate()
    const [name, setName] = useState("");
    const [userName, setuserName] = useState("");
    const [email, setEmail] = useState("");
    const [userPassword, setPassword] = useState("");
    const init = async () => {
        const res = await axios.post(`${BaseURL}registerNewUser`,
            {
                email, name, userName, userPassword
            }
        )
        const data = res.status;
        if (data === 200)
            nav('/Login')
    }
    function navigate() {
        nav('/Login')
    }
    function isEmail(email) {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email); 
     }

    function printError(id, message) {
        document.getElementById(id).innerHTML = message;
    }
    function validateForm() {
        let name = document.getElementById('name').value;
        let userName = document.getElementById('userName').value;
        let password = document.getElementById('password').value;
        let email = document.getElementById('email').value;
        let noErr = true;
        if (userName.length == 0) {
            toastify("Username should be Minimum 1 letter","error");
            noErr = false
        }
        else {
            if (userName.length === 0) {
                toastify("User Name should be Minimum 1 letter","error");
                noErr = false
            } else {
                noErr = true
            }
        }
        if (name.length == 0) {
            toastify("Name should be Minimum 1 letter","error");
            noErr = false
        }
        else {
            if (name.length === 0) {
                toastify("Name should be Minimum 1 letter","error");
                noErr = false
            } else {
                noErr = true
            }
        }
        if (password.length < 1) {
            toastify("Password should be minimum 2 charater", "error");
            noErr = false
        }
        else {
            if (password.length < 1) {
                toastify("Password should be minimum 2 charater", "error");
                noErr = false
            }
            else {
                noErr = true
            }
        }
        if(!isEmail(email)){
            noErr = false
            toastify("Invalid Mail Address","error");
        }
        else{
            if(noErr === true)
               noErr = true
        }
        if (noErr === true)
            init()
    }
    return (
        <div>
            <div>
                <div className="container register">
                    <div className="row">

                    <div className="w-50 d-none d-xl-block d-lg-block d-md-block">
                <img onClick={()=>nav("/")} className='w-75' style={{marginLeft: "65%", marginBottom: "10%"}} src="https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png" alt=""/>
                
            </div>

                        <div className="d-none d-xl-block d-lg-block d-md-block mx-auto col-md-9 register-right">
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <h3 className="register-heading">Register</h3>
                                    <div className="row register-forms">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" id='name' className="form-control" placeholder="Name *" value={name} onChange={(e) => setName(e.target.value)} />
                                                
                                            </div>
                                            <div className="form-group">
                                                <input type="email" id='email' className="form-control" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" id='userName' className="form-control" placeholder="User Name *" value={userName} onChange={(e) => setuserName(e.target.value)} />
                                                
                                            </div>
                                            <div className="form-group">
                                                <input type="password" id='password' className="form-control" placeholder="Password *" value={userPassword} onChange={(e) => setPassword(e.target.value)} />
                                                
                                            </div>
                                            <button className="btn btn-primary" style={{ position: "relative", left: "-50%" }} onClick={validateForm}>Register</button>
                                            <button className="btn btn-primary" style={{ position: "relative", left: "-50%" }} onClick={navigate} >Login</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="w-100 d-block d-xl-none d-lg-none d-md-none">
                <img onClick={()=>nav("/")} className='w-75' style={{marginLeft: "15%", marginBottom: "10%"}} src="https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png" alt=""/>
                
            </div>
                        <div className="d-block d-xl-none d-lg-none d-md-none register-right">
                            <div className="tab-content" id="myTabContent">
                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <h3 className="register-heading">Register</h3>
                                    <div className="row register-forms">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" id='name' className="form-control" placeholder="Name *" value={name} onChange={(e) => setName(e.target.value)} />
                                                
                                            </div>
                                            <div className="form-group">
                                                <input type="email" id='email' className="form-control" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <input type="text" id='userName' className="form-control" placeholder="User Name *" value={userName} onChange={(e) => setuserName(e.target.value)} />
                                                
                                            </div>
                                            <div className="form-group">
                                                <input type="password" id='password' className="form-control" placeholder="Password *" value={userPassword} onChange={(e) => setPassword(e.target.value)} />
                                                
                                            </div>
                                            <button className="btn btn-primary" onClick={validateForm}>Register</button>
                                            <button className="btn btn-primary" onClick={navigate} >Login</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register